import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=3566afd3&"
import script from "./BackToTopButton.vue?vue&type=script&lang=js&"
export * from "./BackToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BackToTopButton.vue
// module id = 194
// module chunks = 0